import React from 'react'

export default function(props) {
	const { result } = props

	return (
		<div>
			<h3 className="result-title">{result.title}</h3>
		</div>
	)
}